/* src/modules/students/api.js */

import gql from 'graphql-tag';
import { REVIEW_CUSTOM_FRAGMENT } from '../tutors/api';
import { STUDENT_LESSON_FRAGMENT } from '../lessons/api';

const STUDENT_FRAGMENT = gql`
  fragment StudentFragment on Student {
    _id
    user {
      _id
      first
      last
      email
    }
    subsidyCredits {
      subsidyId
      credits
      creditsSpent
      status
      requestedAt {
        timestamp
      }
      approvedAt {
        timestamp
      }
    }
    lessons {
      _id
      current {
        timeslots {
          _id
        }
      }
      status
    }
  }
`;

export const FETCH_STUDENTS_QUERY = gql`
  query FetchStudents($studentSearchInput: StudentSearchInput) {
    students(input: $studentSearchInput) {
      ...StudentFragment
    }
  }
  ${STUDENT_FRAGMENT}
`;

const SINGLE_STUDENT_FRAGMENT = gql`
  fragment SingleStudentFragment on Student {
    _id
    user {
      _id
      first
      last
      avatar
      email
      phone
      howDidYouHear
      notes {
        _id
        admin {
          _id
          user {
            _id
            first
            last
          }
        }
        body
        createdAt {
          timestamp
        }
      }
      paymentErrors {
        transactionType
        type
        code
        createdAt {
          timestamp
        }
      }
    }
    bio
    lessons {
      ...StudentLessonFragment
    }
    reviewsGiven {
      ...ReviewCustomFragment
    }
    reviews {
      ...ReviewCustomFragment
    }
    referred {
      _id
    }
    cards {
      id
      last4
      default
    }
    credits
  }
  ${STUDENT_LESSON_FRAGMENT}
  ${REVIEW_CUSTOM_FRAGMENT}
`;

export const FETCH_STUDENT_QUERY = gql`
  query FetchStudent($student: ID!) {
    studentByID(_student: $student) {
      ...SingleStudentFragment
    }
  }
  ${SINGLE_STUDENT_FRAGMENT}
`;

export const ADD_CREDITS_MUTATION = gql`
  mutation addCredits($student: ID!, $amount: Int!) {
    addCredits(_student: $student, amount: $amount) {
      ...SingleStudentFragment
    }
  }
  ${SINGLE_STUDENT_FRAGMENT}
`;

export const REMOVE_STUDENT_MUTATION = gql`
  mutation removeStudent($student: ID!) {
    removeStudent(_student: $student)
  }
`;



// WEBPACK FOOTER //
// ./src/modules/students/api.js